const {
  utm_terms: utmCampaignTerms,
  utm_discount_text: utmCampaignText,
  enabled: utmCampaignEnabled,
} = window.theme.utm_discount;

// _tl_utm_banner cookie is referenced in GTM
const UTM_COOKIE = '_tl_utm_banner';
const DISCOUNT_COOKIE = 'discount_code';

// Wait until page is loaded, then reveal the banner with the appropriate copy
const showDiscountBanner = (copy = '') => {
  const bannerElement = document.querySelector('.js-discount-banner');
  const bannerTextElement = document.querySelector('.discount-banner__content-utmtext');

  // UTM banner
  if (bannerElement && bannerTextElement && copy) {
    bannerTextElement.innerHTML = copy;
    bannerElement.classList.add('discount-banner-utm');
  }

  // Discount banner
  if (bannerElement) {
    bannerElement.classList.add('is-valid');
  }

  // Send GA4 data on click event
  bannerElement.addEventListener('click', () => {
    // eslint-disable-next-line no-unused-expressions
    window.sendGTMData && window.sendGTMData(
      {
        event: 'discount_banner_click',
        copy,
      },
    );
  });
};

async function initBanner() {
  const params = getURLParams();
  const isUTMCampaign = utmCampaignTerms?.includes(params?.utm_campaign);
  if (isUTMCampaign) {
    jsCookie.set(UTM_COOKIE, params.utm_campaign);
  }
  // Show promo banner if a specific session cookie is present
  if (jsCookie.get(UTM_COOKIE) && utmCampaignText && utmCampaignEnabled) {
    showDiscountBanner(utmCampaignText);
    return;
  }

  // If a discount is present in the URL
  if (params.discount) {
    jsCookie.set(DISCOUNT_COOKIE, params.discount);
    showDiscountBanner();
    // Apply discount in cart
    const discountInCart = await window.cartManager.applyDiscountCode(params.discount);
    if (!discountInCart) {
      localStorage.removeItem("discountCode");
    }

    // Remove the URL parameter regardless of what happens
    const newParams = {};
    Object.keys(params).forEach((param) => {
      if (param !== 'discount') {
        newParams[param] = params[param];
      }
    });
    setURLParams(newParams, { clear: true });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  initBanner();
});
